import { lazy } from 'react';
const GatewayRoutes = [
    {
        label: '',
        key: 'gateway',
        path: '/',
        redirect: '/home',
        element: lazy(() => import('@/components/Layout/GatewayLayout')),
        children: [
            {
                label: '自定义页面',
                key: 'custom-page',
                path: '/custom-page',
                element: lazy(() => import('@/page/CustomPage'))
            },
            {
                key: 'home',
                path: 'home',
                show: true,
                isHeaderImage: true, // 是否需要头图
                isFooter: true,
                element: lazy(() => import('@/page/GatewayHome'))
            },
            {
                key: '104', // 项目
                path: '104',
                show: true,
                isHeaderImage: true, // 是否需要头图
                element: lazy(() => import('@/page/GatewayProject'))
            },
            {
                key: '101', // 开放课
                path: '101',
                show: true,
                isHeaderImage: true, // 是否需要头图
                element: lazy(() => import('@/page/GatewayOpenClasses'))
            },
            {
                key: '103', // 直播 / 研讨会
                path: '103',
                show: true,
                isHeaderImage: true, // 是否需要头图
                element: lazy(() => import('@/page/GatewayWorkshop'))
            },
            {
                key: '202', //展示互动
                path: '202',
                show: true,
                isHeaderImage: true, // 是否需要头图
                element: lazy(() => import('@/page/GatewayLectureHall'))
            },
            {
                key: '107', // 听书
                path: '107',
                show: true,
                isHeaderImage: true, // 是否需要头图
                element: lazy(() => import('@/page/GatewayListeningToBooks'))
            },
            {
                key: '108', // 父母学堂
                path: '108',
                show: true,
                isHeaderImage: true, // 是否需要头图
                element: lazy(() => import('@/page/GatewayParentsSchool'))
            },
            {
                key: '109', // 活动
                path: '109',
                show: true,
                isHeaderImage: true, // 是否需要头图
                element: lazy(() => import('@/page/GatewayActivity'))
            },
            {
                key: '201', // 大赛
                path: '201',
                show: true,
                isHeaderImage: true, // 是否需要头图
                element: lazy(() => import('@/page/GatewayCompetition'))
            },
            {
                key: 'lecturer', // 讲师
                path: 'lecturer',
                show: true,
                isHeaderImage: true, // 是否需要头图
                element: lazy(() => import('@/page/GatewayLecturer'))
            },
            {
                key: 'news', // 资讯
                path: 'news',
                show: true,
                isHeaderImage: true, // 是否需要头图
                element: lazy(() => import('@/page/GatewayInfo'))
            },
            {
                key: 'news-rms', // 资讯
                path: 'news-rms',
                show: true,
                isHeaderImage: true, // 是否需要头图
                element: lazy(() => import('@/page/GatewayInfo/indexRms'))
            },
            {
                key: 'e-mall', // 商城
                path: 'e-mall',
                show: true,
                isHeaderImage: true, // 是否需要头图
                element: lazy(() => import('@/page/GatewayEMall'))
            },
            {
                key: 'business-detail', // 业务详情页
                path: 'business-detail',
                show: true,
                isHeaderImage: false, // 是否需要头图
                element: lazy(() => import('@/page/GatewayBusinessDetail'))
            },

            {
                key: 'good-detail', // 业务详情页
                path: 'good-detail',
                show: true,
                isHeaderImage: false, // 是否需要头图
                element: lazy(() => import('@/page/GatewayBusinessDetail/GoodDetail'))
            },
            {
                key: 'news-detail', // 资讯详情页
                path: 'news-detail',
                show: true,
                isHeaderImage: false, // 是否需要头图
                element: lazy(() => import('@/page/GatewayInfoDetail'))
            },
            {
                key: 'news-detail-rms', // 资讯详情页
                path: 'news-detail-rms',
                show: true,
                isHeaderImage: false, // 是否需要头图
                element: lazy(() => import('@/page/GatewayInfoDetail/indexRms'))
            },
            {
                key: 'search-result', // 资讯详情页
                path: 'search-result',
                show: true,
                isHeaderImage: false, // 是否需要头图
                element: lazy(() => import('@/components/Layout/GatewayLayout/Search/SearchResult'))
            },
            {
                label: '帖子列表',
                key: 'bbs',
                path: 'bbs',
                show: true,
                isHeaderImage: true, // 是否需要头图
                element: lazy(() => import('@/page/community/Home/index'))
            },
            {
                label: '标签列表',
                key: 'bbs-tagList',
                path: 'bbs-tagList',
                show: true,
                isHeaderImage: false, // 是否需要头图
                element: lazy(() => import('@/page/community/Home/tagList'))
            },
            {
                label: '发布帖子',
                key: 'bbs-posting',
                path: 'bbs-posting',
                show: true,
                isHeaderImage: false, // 是否需要头图
                element: lazy(() => import('@/page/community/posting/index'))
            },
            {
                label: '编辑帖子',
                key: 'bbs-edit',
                path: 'bbs-edit',
                show: true,
                element: lazy(() => import('@/page/community/posting/edit'))
            },
            {
                label: '帖子详情',
                key: 'bbs-detail',
                path: 'bbs-detail',
                show: true,
                isHeaderImage: false, // 是否需要头图
                element: lazy(() => import('@/page/community/Detail/index'))
            },
            {
                label: '智能体介绍页',
                key: 'agent-detail',
                path: 'agent-detail',
                show: true,
                isHeaderImage: false, // 是否需要头图
                element: lazy(() => import('@/page/GatewayBusinessDetail/AgentDetails'))
            },

            {
                key: '*', // 其他
                path: '*',
                show: true,
                element: lazy(() => import('@/page/GatewayAll'))
            }
        ]
    }
];
export default GatewayRoutes;
